import service from '../services/request'

// 获取用户openid
export const getData = function (params) {
  return service({
    method: 'get',
    url: '/weixin/getData',
    params
  })
}